const videosSections = document.querySelectorAll<HTMLElement>('.s-videos')

videosSections.forEach((section) => {
  const loadMoreButton = section.querySelector<HTMLElement>('.s-videos__button .btn')
  const loadMoreButtonWrapper = section.querySelector<HTMLElement>(".s-videos__button")
  const videosGroup = section.querySelector<HTMLElement>('.g-videos__list')
  const moreVideosGroup = section.querySelector<HTMLElement>('.g-videos-more')

  let clicked = false;

  if (!loadMoreButton || !loadMoreButtonWrapper || !videosGroup || !moreVideosGroup) return;

  const videosGroupItems = videosGroup.querySelectorAll<HTMLElement>('.g-videos__item')

  window.addEventListener('resize', () => {
    if (clicked) {
      if (window.matchMedia('screen and (max-width: 1299px)').matches) {
        videosGroupItems.forEach((item) => {
          item.style.setProperty('display', 'flex')
        })
        moreVideosGroup.classList.add("--hidden");
      } else {
        videosGroupItems.forEach((item, index) => {
          if (index > 2) {
            item.style.setProperty('display', 'none')
          }
        })
        moreVideosGroup.classList.remove("--hidden");
      }
    }
  })

  loadMoreButton.addEventListener('click', () => {
    clicked = true;

    if (window.matchMedia('screen and (max-width: 1299px)').matches) {
      videosGroupItems.forEach((item) => {
        item.style.setProperty('display', 'flex')
      })
      moreVideosGroup.classList.add("--hidden");
    } else {
      moreVideosGroup.classList.remove("--hidden");
    }

    loadMoreButtonWrapper.classList.add("--hidden");
  })
})
